import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, Select, Button, Row, Col, Input, Form, Checkbox, Icon } from 'antd'

import ServicefieldsPopup from '@components/Popup/ServicefieldsPopup'
import CollectionTypesPopup from '@components/Popup/CollectionTypesPopup'

@inject((store: any) => {
    const { doctorsStore, specializationsStore, companiesStore, regionsStore } = store
    return { doctorsStore, specializationsStore, companiesStore, regionsStore }
})
@observer
class SearchBar extends Component<any, any> {
    state = {
        showAdditionalSearch: false
    }

    componentDidMount() {
        this.getTypes()
    }
    toggleCollapseAdditionalSearch = () => {
        this.setState(prevState => ({ showAdditionalSearch: !(prevState as any).showAdditionalSearch }))
    }
    handleFilterChange = (name, value) => {
        const { setFilter } = this.props.doctorsStore
        setFilter(name, value)
    }

    getTypes = async () => {
        const { specializationsStore, companiesStore, regionsStore } = this.props
        await specializationsStore.getSpecializations()
        await companiesStore.getCompanies()
        await regionsStore.getRegions()
    }

    render() {
        const { specializationsStore, companiesStore, regionsStore } = this.props
        const { filters, getDoctors, resetFilters, paging } = this.props.doctorsStore
        const resultsTitle = `נמצאו ${paging.total} רופאים`
        const companies = companiesStore.list.filter(company => company.type !== 'GOV')
        return (
            <Form
                onSubmit={e => {
                    e.preventDefault()
                    getDoctors(1)
                }}
            >
                <Layout style={{ padding: '0 1rem' }}>
                    <Row style={{ display: 'flex', alignItems: 'center' }}>
                        <Col xs={5} style={{ padding: '0 0.5rem' }}>
                            <strong>חיפוש חופשי לפי שם הרופא</strong>
                            <Input.Search
                                placeholder="הזן שם מלא או חלקי"
                                value={filters.name}
                                onChange={e => {
                                    this.handleFilterChange('name', e.target.value)
                                }}
                            />
                        </Col>
                        <Col xs={5} style={{ padding: '0 0.5rem' }}>
                            <strong>סינון לפי התמחויות</strong>
                            <Select
                                style={{ width: '100%' }}
                                value={filters.specialization}
                                onChange={e => {
                                    this.handleFilterChange('specialization', e)
                                    getDoctors(1)
                                }}
                                placeholder="כל ההתמחויות"
                            >
                                <Select.Option value={null}>כל ההתמחויות</Select.Option>
                                {specializationsStore.list.map(specialization => (
                                    <Select.Option key={specialization.id} value={specialization.name}>
                                        {specialization.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col xs={5} style={{ padding: '0 0.5rem' }}>
                            <strong>סינון לפי חברות</strong>
                            <Select
                                style={{ width: '100%' }}
                                value={filters.company}
                                onChange={e => {
                                    this.handleFilterChange('company', e)
                                    getDoctors(1)
                                }}
                                placeholder="כל החברות"
                            >
                                <Select.Option value={null}>כל החברות</Select.Option>
                                {companies.map(company => (
                                    <Select.Option key={company.id} value={company.name}>
                                        {company.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col xs={5} style={{ padding: '0 0.5rem' }}>
                            <strong>חיפוש חופשי לפי מקצוע</strong>
                            <Input.Search
                                placeholder="הזן חלק משם המקצוע"
                                value={filters.speciality}
                                onChange={e => {
                                    this.handleFilterChange('speciality', e.target.value)
                                }}
                            />
                        </Col>
                        <Col xs={4} style={{ padding: '0 0.5rem' }}>
                            <strong>חיפוש חופשי לפי יישוב</strong>
                            <Input.Search
                                placeholder="הזן חלק משם היישוב"
                                value={filters.city}
                                onChange={e => {
                                    this.handleFilterChange('city', e.target.value)
                                }}
                            />
                        </Col>
                    </Row>

                    <Row style={{ display: 'flex', alignItems: 'center', padding: '0.5rem' }}>
                        <Col xs={20}>
                            <a href="#">
                                <span
                                    style={{ textDecoration: 'underline' }}
                                    onClick={() => this.toggleCollapseAdditionalSearch()}
                                >
                                    חיפושים נוספים
                                </span>
                                {this.state.showAdditionalSearch ? (
                                    <Icon type="arrow-up" />
                                ) : (
                                    <Icon type="arrow-down" />
                                )}
                            </a>
                        </Col>
                    </Row>
                    {this.state.showAdditionalSearch && (
                        <Row style={{ display: 'flex', alignItems: 'center' }}>
                            <Col xs={4} style={{ padding: '0 0.5rem' }}>
                                <strong>סינון לפי איזור</strong>
                                <Select
                                    style={{ width: '100%' }}
                                    value={filters.region}
                                    onChange={e => {
                                        this.handleFilterChange('region', e)
                                        getDoctors(1)
                                    }}
                                    placeholder="כל האיזורים"
                                >
                                    <Select.Option value={null}>כל האיזורים</Select.Option>
                                    {regionsStore.list.map((region, index) => (
                                        <Select.Option key={index} value={region.region_name}>
                                            {region.region_name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col xs={3} style={{ padding: '0 0.5rem' }}>
                                <strong>סינון לפי שב"ן</strong>
                                <Select
                                    style={{ width: '100%' }}
                                    value={filters.shaban}
                                    onChange={e => {
                                        this.handleFilterChange('shaban', e)
                                        getDoctors(1)
                                    }}
                                    placeholder='שב"ן/ללא שב"ן'
                                >
                                    <Select.Option value={null}>שב"ן/ללא שב"ן</Select.Option>
                                    <Select.Option value={0}>ללא שב"ן</Select.Option>
                                    <Select.Option value={1}>שב"ן</Select.Option>
                                </Select>
                            </Col>
                            <Col xs={3} style={{ padding: '0 0.5rem' }}>
                                <strong>סינון לפי ראשוני/שניוני</strong>
                                <Select
                                    style={{ width: '100%' }}
                                    value={filters.initial}
                                    onChange={e => {
                                        this.handleFilterChange('initial', e)
                                        getDoctors(1)
                                    }}
                                    placeholder="ראשוני/שניוני"
                                >
                                    <Select.Option value={null}>ראשוני/שניוני</Select.Option>
                                    <Select.Option value={1}>ראשוני בלבד</Select.Option>
                                    <Select.Option value={0}>שניוני בלבד</Select.Option>
                                </Select>
                            </Col>
                            <Col xs={3} style={{ padding: '0 0.5rem' }}>
                                <strong>פרופ'/לא פרופ'</strong>
                                <Select
                                    style={{ width: '100%' }}
                                    value={filters.professor}
                                    onChange={e => {
                                        this.handleFilterChange('professor', e)
                                        getDoctors(1)
                                    }}
                                    placeholder="פרופ'/לא פרופ'"
                                >
                                    <Select.Option value={null}>פרופ'/לא פרופ'</Select.Option>
                                    <Select.Option value={1}>פרופ'</Select.Option>
                                    <Select.Option value={0}>לא פרופ'</Select.Option>
                                </Select>
                            </Col>
                            <Col xs={3} style={{ padding: '0 0.5rem' }}>
                                <strong>חיפוש לפי מזהה</strong>
                                <Input.Search
                                    placeholder="הזן מזהה רופא"
                                    value={filters.id}
                                    onChange={e => {
                                        this.handleFilterChange('id', e.target.value)
                                    }}
                                />
                            </Col>
                            <Col xs={4} style={{ padding: '0 0.5rem' }}>
                                <strong>חיפוש חופשי לפי תפקיד</strong>
                                <Input.Search
                                    placeholder="הזן חלק מהגדרת התפקיד"
                                    value={filters.position}
                                    onChange={e => {
                                        this.handleFilterChange('position', e.target.value)
                                    }}
                                />
                            </Col>
                            <Col xs={5}>
                                <strong> רק רופאים שמקום עבודתם ידוע </strong>
                                <div>
                                    <Checkbox
                                        style={{ padding: '0 0.5rem' }}
                                        checked={filters.with}
                                        onChange={e => {
                                            this.handleFilterChange('with', e.target.checked)
                                            getDoctors(1)
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col xs={20}>
                            <Button
                                style={{ margin: '0' }}
                                onClick={() => {
                                    resetFilters()
                                    getDoctors(1)
                                }}
                            >
                                איפוס חיפוש
                            </Button>
                            <Button type="primary" style={{ margin: '0.8rem 0.5rem 0' }} htmlType="submit">
                                חפש רופאים
                            </Button>
                            <span style={{ fontSize: '1rem' }}>{resultsTitle}</span>
                        </Col>
                    </Row>
                </Layout>
                <ServicefieldsPopup />
                <CollectionTypesPopup />
            </Form>
        )
    }
}

export default withRouter(SearchBar)
